<template>
  <k-page class="page-promocodes">
    <div class="page-promocodes__controls">
      <el-tooltip content="Оновити дані" placement="top">
        <el-button @click="update" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isPromocodesLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Добавить старт" placement="top">
        <el-button @click="handleAdd" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="promocodesCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-promocodes-list
      :promocodes="promocodes"
      @edit="setPromocode"
      @delete="deletePromocode"
    />

    <!-- BEGIN: Pagination -->
    <el-pagination
      v-if="numberOfPages > 1"
      @current-change="setCurrentPage"
      class="the-utils-emails__pagination"
      background
      layout="prev, pager, next"
      :total="promocodesCount"
      small
    >
    </el-pagination>
    <!-- END: Pagination -->

    <k-promocode-edit-form
      :dialogFormVisible="activePromocode !== '' || creatigNew"
      :promocode="promocode"
      @cancel="handleCancel"
      @update="handleUpdateAfterAdd"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница промокодов
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';

import formatDate from '@/util/formatDate';

// Components
import KPage from '@/components/KPage.vue';
import KPromocodeEditForm from '@/components/KPromocodeEditForm.vue';
import KPromocodesList from '@/components/KPromocodesList.vue';


const NUMBER_OF_PROMOCODES_PER_PAGE = 10;

export default {
  name: 'page-promocodes',

  data() {
    return {
      activePromocode: '',
      creatigNew: false,
      currentPage: 0,
    };
  },

  computed: {
    // Общее количество страниц
    numberOfPages() {
      return Math.ceil(this.promocodesCount / NUMBER_OF_PROMOCODES_PER_PAGE);
    },

    promocode() {
      const promocode = this.promocodes.find(item => item._id === this.activePromocode);

      return this.creatigNew || !promocode
        ? {}
        : promocode;
    },

    ...mapGetters({
      isPromocodesLoading: 'promocodes/isPromocodesLoading',
      promocodes: 'promocodes/promocodes',
      promocodesCount: 'promocodes/promocodesCount',
    }),
  },

  async created() {
    await this.update();
  },

  methods: {
    async update() {
      await this.getPromocodes({
        limit: NUMBER_OF_PROMOCODES_PER_PAGE,
        offset: this.currentPage,
      });
    },

    setPromocode(id) {
      this.activePromocode = id;
    },

    async setCurrentPage(numberOfPage) {
      this.currentPage = numberOfPage - 1;
      await this.update();
    },

    handleCancel() {
      this.creatigNew = false;
      this.activePromocode = '';
    },

    async handleUpdateAfterAdd() {
      await this.update();
      this.creatigNew = false;
      this.activePromocode = '';
    },

    async deletePromocode(id) {
      await this.deletePromocodes([id]);
      await this.update();
    },

    // Добавление акции
    handleAdd() {
      this.creatigNew = true;
    },

    formatDate,

    ...mapActions({
      deletePromocodes: 'promocodes/deletePromocodes',
      getPromocodes: 'promocodes/getPromocodes',
    }),
  },

  components: {
    KPage,
    KPromocodeEditForm,
    KPromocodesList,
  },
};
</script>

<style lang="scss">
  .page-promocodes {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }
  }
</style>
